import styles from './CircleCountdown.module.scss';

export interface CircleCountdownProps {
  /**
   * Total time in seconds
   */
  seconds: number;

  /**
   * Total time in seconds to calculate progress
   */
  totalSeconds: number;

  /**
   * Additional CSS class name
   */
  className?: string;
}

export function CircleCountdown({
  seconds,
  totalSeconds,
  className,
}: CircleCountdownProps) {
  // Calculate the circumference
  const radius = 54;
  const circumference = 2 * Math.PI * radius;

  // Calculate the stroke dashoffset based on time remaining
  const progress = seconds / totalSeconds;
  const strokeDashoffset = circumference * (1 - progress);

  return (
    <div className={`${styles.wrapper} ${className || ''}`}>
      <div className={styles.container}>
        <svg
          className={styles.outerCircle}
          width="116"
          height="116"
          viewBox="0 0 116 116"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Background circle (static, gray) */}
          <circle
            cx="58"
            cy="58"
            r="54"
            stroke="#DFE2E2"
            strokeWidth="4"
            fill="none"
          />
          {/* Progress circle (animating) */}
          <circle
            cx="58"
            cy="58"
            r="54"
            stroke="rgba(45, 45, 240, 1)"
            strokeWidth="4"
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            transform="rotate(-90 58 58)"
          />
        </svg>
        <svg
          className={styles.innerCircle}
          width="112"
          height="112"
          viewBox="0 0 112 112"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="56" cy="56" r="56" fill="#F4F5F5" />
        </svg>
        <div className={styles.timerText}>
          {Math.floor(seconds / 60)
            .toString()
            .padStart(2, '0')}
          :{(seconds % 60).toString().padStart(2, '0')}
        </div>
      </div>
    </div>
  );
}
